import { fetchWithTimeout, parseErrorResponse } from './base.ts';

export const auditApi = {
  /**
   * Fetch audit logs for the authenticated user (all projects).
   */
  getAuditLogs: async (
    filters: {
      entity_type?: string;
      action?: string;
      limit?: number;
      offset?: number;
    } = {}
  ): Promise<any[]> => {
    const params = new URLSearchParams();
    if (filters.entity_type) params.set('entity_type', filters.entity_type);
    if (filters.action) params.set('action', filters.action);
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.offset) params.set('offset', String(filters.offset));

    const qs = params.toString();
    const url = `/api/audit-logs${qs ? `?${qs}` : ''}`;
    const res = await fetchWithTimeout(url);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Fetch project-scoped audit logs with optional filters.
   */
  getProjectAuditLogs: async (
    projectId: string,
    filters: {
      entity_type?: string;
      entity_id?: string;
      related_person_id?: string;
      action?: string;
      limit?: number;
      offset?: number;
    } = {}
  ): Promise<any[]> => {
    const params = new URLSearchParams();
    if (filters.related_person_id) {
      params.set('related_person_id', filters.related_person_id);
    } else {
      if (filters.entity_type) params.set('entity_type', filters.entity_type);
      if (filters.entity_id) params.set('entity_id', filters.entity_id);
    }
    if (filters.action) params.set('action', filters.action);
    if (filters.limit) params.set('limit', String(filters.limit));
    if (filters.offset) params.set('offset', String(filters.offset));

    const qs = params.toString();
    const url = `/api/projects/${projectId}/audit-logs${qs ? `?${qs}` : ''}`;
    const res = await fetchWithTimeout(url);
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },

  /**
   * Undo a specific audit log action (restore previous state).
   */
  undoAuditAction: async (logId: string): Promise<any> => {
    const res = await fetchWithTimeout(`/api/audit-logs/${logId}/undo`, {
      method: 'POST',
    });
    if (!res.ok) await parseErrorResponse(res);
    return res.json();
  },
};
